export const OPEN_ASSISTANT_CHAT_EVENT = "omer:open-assistant-chat";

export type OpenAssistantChatDetail = { prompt: string };

export function openAssistantChat(prompt: string): void {
  window.dispatchEvent(new CustomEvent<OpenAssistantChatDetail>(OPEN_ASSISTANT_CHAT_EVENT, { detail: { prompt } }));
}
